/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Suggested severity level.
 */
export const SuggestCustomDetectionRuleResultSeverity = {
  Info: "info",
  Low: "low",
  Medium: "medium",
  High: "high",
  Critical: "critical",
} as const;
/**
 * Suggested severity level.
 */
export type SuggestCustomDetectionRuleResultSeverity = OpenEnum<
  typeof SuggestCustomDetectionRuleResultSeverity
>;

export type SuggestCustomDetectionRuleResult = {
  /**
   * Description of what the rule detects and why it matters.
   */
  description: string;
  /**
   * Suggested CEL detection predicate.
   */
  detectionExpr?: string | undefined;
  /**
   * Deprecated legacy regex suggestion; superseded by detection_expr. Present for backward compatibility.
   */
  regex: string;
  /**
   * Suggested stable identifier, prefixed with `custom.`.
   */
  ruleId: string;
  /**
   * Suggested severity level.
   */
  severity: SuggestCustomDetectionRuleResultSeverity;
  /**
   * Short, human-friendly title for the rule.
   */
  title: string;
};

/** @internal */
export const SuggestCustomDetectionRuleResultSeverity$inboundSchema:
  z.ZodMiniType<SuggestCustomDetectionRuleResultSeverity, unknown> = openEnums
    .inboundSchema(SuggestCustomDetectionRuleResultSeverity);

/** @internal */
export const SuggestCustomDetectionRuleResult$inboundSchema: z.ZodMiniType<
  SuggestCustomDetectionRuleResult,
  unknown
> = z.pipe(
  z.object({
    description: z.string(),
    detection_expr: z.optional(z.string()),
    regex: z.string(),
    rule_id: z.string(),
    severity: SuggestCustomDetectionRuleResultSeverity$inboundSchema,
    title: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "detection_expr": "detectionExpr",
      "rule_id": "ruleId",
    });
  }),
);

export function suggestCustomDetectionRuleResultFromJSON(
  jsonString: string,
): SafeParseResult<SuggestCustomDetectionRuleResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SuggestCustomDetectionRuleResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SuggestCustomDetectionRuleResult' from JSON`,
  );
}
